const FIELD_TYPES = {
  dateRange: "date_range"
};
const CONFIG_LAYOUTS = {
  REPORT: "report",
  HERO_OVERVIEW: "hero_overview"
};
export {
  CONFIG_LAYOUTS,
  FIELD_TYPES
};
